var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent } from "vue";
const _hoisted_1 = { class: "w-full px-4 hl-header-container" };
const _hoisted_2 = { class: "flex items-center justify-content-between" };
const _hoisted_3 = { class: "hl-media-title title title-extra-slots hl-display-sm-medium" };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { class: "hl-media-actions" };
const _hoisted_6 = { class: "flex items-center" };
const _hoisted_7 = ["src"];
const _hoisted_8 = ["src"];
const _hoisted_9 = ["src"];
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("br", null, null, -1 /* HOISTED */);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("br", null, null, -1 /* HOISTED */);
const _hoisted_12 = {
    key: 3,
    class: "vertical-border border-r-2 border-gray-200"
};
const _hoisted_13 = {
    key: 0,
    lass: "flex items-center"
};
const _hoisted_14 = {
    key: 1,
    class: "flex items-center"
};
const _hoisted_15 = { key: 0 };
const _hoisted_16 = { key: 1 };
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("div", { class: "vertical-border border-r-2 border-gray-200" }, null, -1 /* HOISTED */);
import useAppEmitter from '@/composable/useEmitter';
import MediaServices from '@/services/MediaService';
import { useStore } from '@/store';
import { CustomContentAiIcon } from '@gohighlevel/ghl-icons/24/custom';
import { formatBytes } from '../util/helper';
import { FolderPlusIcon, HardDriveIcon, Upload01Icon, } from '@gohighlevel/ghl-icons/24/outline';
import { UIBreadcrumb, UIBreadcrumbItem, UIButton, UIHeader, UITextSmMedium, UITextXsRegular, UITooltip, } from '@gohighlevel/ghl-ui';
import config from 'src/config';
import { computed, inject, onBeforeMount, onBeforeUnmount, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import GoogleDriveIcon from '../assets/img/google-drive.svg';
export default /*#__PURE__*/ _defineComponent({
    __name: 'MediaHeaderv2',
    props: {
        currentFolderLevel: Object,
        contentAIEnable: Boolean,
        showContentAI: Boolean,
    },
    emits: ["uploadMedia", "createFolder", "openImageGenerationForm", "onClickFolder", "setCategory"],
    setup(__props, { emit: __emit }) {
        const { t } = useI18n();
        const parentEmitter = inject('emitter');
        const parentStore = inject('store');
        const emit = __emit;
        const store = useStore();
        const user = inject('user');
        const appEmitter = useAppEmitter();
        const storageUsage = ref();
        const connectToGoogleDriveWindow = ref();
        const storageUsageError = ref(false);
        const googleConnection = ref();
        const loadingGoogleDriveInfo = ref(false);
        const googleDriveUserInfo = ref([]);
        const errorGettingDriveInfo = ref(false);
        const googleWindow = ref();
        const isFirstFetchCalled = ref(false);
        const totalDriveUsage = ref(0);
        const altId = store.altId;
        const altType = store.altType;
        const selfHosted = computed(() => {
            return store.selfHosted;
        });
        const loggedInUserGoogleConnection = computed(() => {
            if (!googleConnection.value)
                return [];
            const loggedInUserGoogleConnection = googleConnection.value.filter(connection => connection.userId == store.userId && !isProxyUser.value);
            return loggedInUserGoogleConnection;
        });
        const onClickFolder = (folder) => {
            emit('onClickFolder', folder);
        };
        const isProxyUser = computed(() => parentStore === null || parentStore === void 0 ? void 0 : parentStore.getters['auth/isProxyUser']);
        const openImageAI = () => {
            emit('openImageGenerationForm');
        };
        function removeDuplicates(data) {
            const uniqueIds = new Set();
            const uniqueData = [];
            data.forEach(item => {
                if (!uniqueIds.has(item._id)) {
                    uniqueIds.add(item._id);
                    uniqueData.push(item);
                }
            });
            return uniqueData;
        }
        const calculateUsage = () => __awaiter(this, void 0, void 0, function* () {
            try {
                storageUsage.value = undefined;
                storageUsageError.value = false;
                if (altType === 'location') {
                    const { data } = yield MediaServices.getLocationUsage({
                        altId,
                        altType,
                    });
                    storageUsage.value = data === null || data === void 0 ? void 0 : data.usage;
                    storageUsageError.value = false;
                }
            }
            catch (error) {
                storageUsage.value = 0;
                storageUsageError.value = true;
            }
        });
        const getDriveStorageUsage = () => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            try {
                const mappedConnections = [];
                const connections = (_a = googleConnection.value) === null || _a === void 0 ? void 0 : _a.map((connection) => __awaiter(this, void 0, void 0, function* () {
                    var _c, _d;
                    if (connection.userId === store.userId) {
                        let response;
                        try {
                            response = yield MediaServices.getGooglDriveInfo({
                                connectionId: connection.id,
                            });
                        }
                        catch (error) {
                            console.error('Drive data not found', error);
                        }
                        if (!((_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.user))
                            return;
                        const data = response.data;
                        if (connection.userId === store.userId && !isProxyUser.value)
                            mappedConnections.push(connection);
                        // Find the index of the object with the same id
                        const index = googleDriveUserInfo.value.findIndex(userInfo => userInfo.user.emailAddress === data.user.emailAddress);
                        const newData = {
                            storageUsed: formatBytes((_d = data.storageQuota.usageInDrive) !== null && _d !== void 0 ? _d : 0),
                            user: data.user,
                            storageQuota: data.storageQuota,
                        };
                        if (index !== -1) {
                            googleDriveUserInfo.value[index] = Object.assign({}, newData);
                        }
                        else {
                            googleDriveUserInfo.value.push(newData);
                        }
                    }
                }));
                yield Promise.all(connections);
                store.setGoogleConnectInfo(mappedConnections);
                totalDriveUsage.value = 0;
                (_b = googleDriveUserInfo.value) === null || _b === void 0 ? void 0 : _b.map(userInfo => {
                    var _a;
                    totalDriveUsage.value += Number((_a = userInfo.storageQuota) === null || _a === void 0 ? void 0 : _a.usageInDrive);
                });
                loadingGoogleDriveInfo.value = false;
            }
            catch (error) {
                errorGettingDriveInfo.value = true;
                loadingGoogleDriveInfo.value = false;
                console.error('Drive data not found', error);
            }
        });
        const getGoogleDriveConnectionInfo = () => __awaiter(this, void 0, void 0, function* () {
            var _e;
            try {
                loadingGoogleDriveInfo.value = true;
                const { data } = yield MediaServices.getGoogleDriveConnectionInfo({
                    locationId: store.altId,
                });
                if (((_e = data === null || data === void 0 ? void 0 : data.connections) === null || _e === void 0 ? void 0 : _e.length) >= 1) {
                    googleConnection.value = data.connections;
                }
                if (googleWindow.value &&
                    googleWindow.value.closed &&
                    googleConnection.value &&
                    !isFirstFetchCalled.value) {
                    // when connected to google drive through media storage
                    isFirstFetchCalled.value = true;
                    yield fetchGoogleDriveData();
                }
                else if (!googleWindow.value &&
                    googleConnection.value &&
                    !isFirstFetchCalled.value // already connected and google drive data is available
                ) {
                    isFirstFetchCalled.value = true;
                    yield getDriveStorageUsage();
                }
                loadingGoogleDriveInfo.value = false;
            }
            catch (error) {
                loadingGoogleDriveInfo.value = false;
                console.error(error);
            }
        });
        const connectToDrive = () => {
            loadingGoogleDriveInfo.value = true;
            googleWindow.value = window.open(config.appengineURL +
                '/api/gmail/start_oauth?location_id=' +
                store.altId +
                '&user_id=' +
                (user === null || user === void 0 ? void 0 : user.id), 'MyWindow', 'toolbar=no, menubar=no,scrollbars=no,resizable=no,location=false,directories=no,status=no');
            connectToGoogleDriveWindow.value = setInterval(() => {
                if (googleWindow.value && googleWindow.value.closed) {
                    clearInterval(connectToGoogleDriveWindow.value);
                    isFirstFetchCalled.value = false;
                    getGoogleDriveConnectionInfo();
                }
            }, 500);
        };
        const fetchGoogleDriveData = () => __awaiter(this, void 0, void 0, function* () {
            loadingGoogleDriveInfo.value = true;
            yield getDriveStorageUsage();
        });
        onBeforeMount(() => __awaiter(this, void 0, void 0, function* () {
            calculateUsage();
            getGoogleDriveConnectionInfo();
            appEmitter.on('calculateStorage', calculateUsage);
            appEmitter.on('calculateDriveStorage', getDriveStorageUsage);
        }));
        onBeforeUnmount(() => __awaiter(this, void 0, void 0, function* () {
            appEmitter.off('calculateStorage', calculateUsage);
            if (connectToGoogleDriveWindow.value) {
                clearInterval(connectToGoogleDriveWindow.value);
            }
            appEmitter.off('calculateDriveStorage', getDriveStorageUsage);
        }));
        const showUsageModel = () => {
            parentEmitter.emit('media-usage-model-open', true);
        };
        return (_ctx, _cache) => {
            const _component_UISpin = _resolveComponent("UISpin");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(UIHeader), {
                    id: "hl-media-center-main-header",
                    title: ""
                }, {
                    header: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                (__props.currentFolderLevel.length == 1)
                                    ? (_openBlock(), _createElementBlock("h2", _hoisted_4, _toDisplayString(_ctx.$t('common.mediaStorage')), 1 /* TEXT */))
                                    : (_openBlock(), _createBlock(_unref(UIBreadcrumb), {
                                        key: 1,
                                        separator: ">"
                                    }, {
                                        default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(removeDuplicates(__props.currentFolderLevel), (folder, index) => {
                                                return (_openBlock(), _createBlock(_unref(UIBreadcrumbItem), { key: index }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_unref(UITextSmMedium), {
                                                            class: _normalizeClass([
                                                                index === __props.currentFolderLevel.length - 1
                                                                    ? 'cursor-default text-curious-blue-500'
                                                                    : 'text-gray-600',
                                                            ]),
                                                            onClick: ($event) => (onClickFolder(folder))
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(folder === null || folder === void 0 ? void 0 : folder.name), 1 /* TEXT */)
                                                            ]),
                                                            _: 2 /* DYNAMIC */
                                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "onClick"])
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1024 /* DYNAMIC_SLOTS */));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                            ]),
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                    (isProxyUser.value)
                                        ? (_openBlock(), _createBlock(_unref(UITooltip), {
                                            key: 0,
                                            placement: "button",
                                            trigger: "hover"
                                        }, {
                                            trigger: _withCtx(() => [
                                                _createVNode(_unref(UIButton), {
                                                    id: "hl-connect-google-drive",
                                                    class: _normalizeClass(['flex items-center h-11']),
                                                    disabled: isProxyUser.value
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("img", {
                                                            src: _unref(GoogleDriveIcon),
                                                            alt: "!",
                                                            class: "mr-2"
                                                        }, null, 8 /* PROPS */, _hoisted_7),
                                                        _createVNode(_unref(UITextSmMedium), null, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(_ctx.$t('common.connectDrive')), 1 /* TEXT */)
                                                            ]),
                                                            _: 1 /* STABLE */
                                                        })
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["disabled"])
                                            ]),
                                            default: _withCtx(() => [
                                                _createVNode(_unref(UITextXsRegular), null, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_unref(t)('common.googleDriveProxyUserTooltip')), 1 /* TEXT */)
                                                    ]),
                                                    _: 1 /* STABLE */
                                                })
                                            ]),
                                            _: 1 /* STABLE */
                                        }))
                                        : (!selfHosted.value &&
                                            (loggedInUserGoogleConnection.value.length <= 0 ||
                                                loadingGoogleDriveInfo.value ||
                                                googleDriveUserInfo.value.length <= 0))
                                            ? (_openBlock(), _createBlock(_unref(UIButton), {
                                                key: 1,
                                                id: "hl-connect-google-drive",
                                                class: "flex items-center h-11",
                                                loading: loadingGoogleDriveInfo.value,
                                                onClick: connectToDrive
                                            }, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("img", {
                                                        src: _unref(GoogleDriveIcon),
                                                        alt: "!",
                                                        class: "mr-2"
                                                    }, null, 8 /* PROPS */, _hoisted_8),
                                                    _createVNode(_unref(UITextSmMedium), null, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(loadingGoogleDriveInfo.value
                                                                ? _ctx.$t('common.connecting')
                                                                : _ctx.$t('common.connectDrive')), 1 /* TEXT */)
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    })
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["loading"]))
                                            : (!selfHosted.value &&
                                                loggedInUserGoogleConnection.value.length >= 1 &&
                                                !loadingGoogleDriveInfo.value &&
                                                googleDriveUserInfo.value.length >= 1)
                                                ? (_openBlock(), _createBlock(_unref(UITooltip), {
                                                    key: 2,
                                                    placement: "button",
                                                    trigger: "hover"
                                                }, {
                                                    trigger: _withCtx(() => [
                                                        _createVNode(_unref(UIButton), {
                                                            id: "hl-connected-google-drive",
                                                            class: _normalizeClass(['flex items-center h-11', ,]),
                                                            loading: loadingGoogleDriveInfo.value
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createElementVNode("img", {
                                                                    src: _unref(GoogleDriveIcon),
                                                                    alt: "!",
                                                                    class: "mr-2"
                                                                }, null, 8 /* PROPS */, _hoisted_9),
                                                                _createVNode(_unref(UITextSmMedium), {
                                                                    class: _normalizeClass(['text-black'])
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(googleDriveUserInfo.value
                                                                            ? _unref(formatBytes)(totalDriveUsage.value)
                                                                            : _ctx.$t('common.connecting')), 1 /* TEXT */)
                                                                    ]),
                                                                    _: 1 /* STABLE */
                                                                })
                                                            ]),
                                                            _: 1 /* STABLE */
                                                        }, 8 /* PROPS */, ["loading"])
                                                    ]),
                                                    default: _withCtx(() => [
                                                        (googleDriveUserInfo.value.length)
                                                            ? (_openBlock(), _createBlock(_unref(UITextXsRegular), { key: 0 }, {
                                                                default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(_unref(t)('common.accountsConnected', [googleDriveUserInfo.value.length])), 1 /* TEXT */)
                                                                ]),
                                                                _: 1 /* STABLE */
                                                            }))
                                                            : _createCommentVNode("v-if", true),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(googleDriveUserInfo.value, (userInfo) => {
                                                            return (_openBlock(), _createBlock(_unref(UITextXsRegular), {
                                                                key: userInfo.user.emailAddress
                                                            }, {
                                                                default: _withCtx(() => {
                                                                    var _a, _b, _c;
                                                                    return [
                                                                        _hoisted_10,
                                                                        _createTextVNode(" " + _toDisplayString(`Username: ${(_a = userInfo === null || userInfo === void 0 ? void 0 : userInfo.user) === null || _a === void 0 ? void 0 : _a.displayName}`) + " ", 1 /* TEXT */),
                                                                        _hoisted_11,
                                                                        _createTextVNode(" " + _toDisplayString(`${_unref(formatBytes)((_b = userInfo === null || userInfo === void 0 ? void 0 : userInfo.storageQuota) === null || _b === void 0 ? void 0 : _b.usageInDrive)} used out of ${_unref(formatBytes)((_c = userInfo === null || userInfo === void 0 ? void 0 : userInfo.storageQuota) === null || _c === void 0 ? void 0 : _c.limit)}`), 1 /* TEXT */)
                                                                    ];
                                                                }),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1024 /* DYNAMIC_SLOTS */));
                                                        }), 128 /* KEYED_FRAGMENT */)),
                                                        (!googleDriveUserInfo.value.length)
                                                            ? (_openBlock(), _createBlock(_unref(UITextXsRegular), { key: 1 }, {
                                                                default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(_ctx.$t('common.errorConnectingDrive')), 1 /* TEXT */)
                                                                ]),
                                                                _: 1 /* STABLE */
                                                            }))
                                                            : _createCommentVNode("v-if", true)
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }))
                                                : _createCommentVNode("v-if", true),
                                    (!selfHosted.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_12))
                                        : _createCommentVNode("v-if", true),
                                    (_unref(altType) === 'location')
                                        ? (_openBlock(), _createBlock(_unref(UITooltip), {
                                            key: 4,
                                            placement: "button",
                                            trigger: "hover"
                                        }, {
                                            trigger: _withCtx(() => [
                                                _createVNode(_unref(UIButton), {
                                                    id: "hl-media-used",
                                                    type: "default",
                                                    class: "h-11",
                                                    loading: !storageUsage.value && !storageUsageError.value,
                                                    onClick: showUsageModel
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("div", {
                                                            class: _normalizeClass(["flex items-center", { 'text-danger': storageUsageError.value }])
                                                        }, [
                                                            _createVNode(_unref(HardDriveIcon), { class: "h-4 w-4 mr-2" }),
                                                            (storageUsage.value || storageUsageError.value)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(storageUsageError.value
                                                                    ? _ctx.$t('common.calculationFailed')
                                                                    : storageUsage.value), 1 /* TEXT */))
                                                                : (_openBlock(), _createElementBlock("span", _hoisted_14, [
                                                                    _createTextVNode(_toDisplayString(_ctx.$t('common.calculating')) + "... ", 1 /* TEXT */),
                                                                    _createVNode(_component_UISpin, {
                                                                        show: true,
                                                                        size: 13,
                                                                        class: "ml-2"
                                                                    })
                                                                ]))
                                                        ], 2 /* CLASS */)
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["loading"])
                                            ]),
                                            default: _withCtx(() => [
                                                (storageUsageError.value)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.$t('common.storageUsageErrorMessage')), 1 /* TEXT */))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_unref(t)('common.storageUsageMessage')), 1 /* TEXT */))
                                            ]),
                                            _: 1 /* STABLE */
                                        }))
                                        : _createCommentVNode("v-if", true),
                                    _hoisted_17,
                                    (__props.showContentAI)
                                        ? (_openBlock(), _createBlock(_unref(UIButton), {
                                            key: 5,
                                            id: "hl-image-ai-action",
                                            class: "flex items-center hl-image-ai-action h-11",
                                            disabled: !__props.contentAIEnable,
                                            onClick: openImageAI
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_unref(CustomContentAiIcon), { class: "h-6 w-6" })
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["disabled"]))
                                        : _createCommentVNode("v-if", true),
                                    _createVNode(_unref(UIButton), {
                                        id: "hl-media-create-folder",
                                        type: "default",
                                        class: "flex items-center ml-2 h-11",
                                        onClick: _cache[0] || (_cache[0] = ($event) => (emit('createFolder')))
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(FolderPlusIcon), { class: "h-5 w-5" })
                                        ]),
                                        _: 1 /* STABLE */
                                    }),
                                    _createVNode(_unref(UIButton), {
                                        id: "hl-media-upload",
                                        type: "primary",
                                        class: "flex items-center hl-image-ai-action ml-2 h-11",
                                        onClick: _cache[1] || (_cache[1] = ($event) => (emit('uploadMedia')))
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(Upload01Icon), { class: "h-5 w-5 mr-2" }),
                                            _createVNode(_unref(UITextSmMedium), null, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_unref(t)('common.upload')), 1 /* TEXT */)
                                                ]),
                                                _: 1 /* STABLE */
                                            })
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ])
                            ])
                        ])
                    ]),
                    _: 1 /* STABLE */
                })
            ]));
        };
    }
});
